import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=1c78002c&scoped=true"
import script from "./DeleteDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./DeleteDialog.vue?vue&type=style&index=0&id=1c78002c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c78002c",
  null
  
)

export default component.exports